import React from 'react';

const Logo = ({ size = 'default', showTagline = false }) => {
  const sizes = {
    small: { text: 'text-xl', tagline: 'text-[8px]', img: 'h-9', gap: 'gap-2' },
    medium: { text: 'text-3xl', tagline: 'text-[10px]', img: 'h-10', gap: 'gap-2' },
    default: { text: 'text-2xl', tagline: 'text-xs', img: 'h-10', gap: 'gap-2' },
    large: { text: 'text-5xl', tagline: 'text-sm', img: 'h-14', gap: 'gap-3' },
    header: { text: 'text-3xl lg:text-4xl', tagline: 'text-xs', img: 'h-12 w-12 lg:h-14 lg:w-14', gap: 'gap-2.5' },
    footer: { text: 'text-3xl', tagline: 'text-xs', img: 'h-[52px] w-[52px]', gap: 'gap-2' },
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center ${s.gap} group cursor-pointer`} dir="ltr" style={{direction: 'ltr'}}>
      <img 
        src="/logo.png"
        alt="Tasty Bites Logo"
        className={`${s.img} object-contain transition-all duration-700 ease-out group-hover:drop-shadow-[0_0_12px_rgba(255,193,7,0.6)] group-hover:-translate-y-1 group-hover:scale-105`}
      />
      <div className="flex flex-col justify-center leading-none min-w-0">
        <div className={`font-bold uppercase tracking-tight font-['Barlow_Condensed'] ${s.text} flex flex-nowrap`} dir="ltr">
          {'TASTY'.split('').map((letter, i) => (
            <span
              key={`t-${i}`}
              className="text-[#FFC107] transition-all duration-300 group-hover:text-white inline-block group-hover:-translate-y-0.5"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              {letter}
            </span>
          ))}
          <span className="w-1.5" />
          {'BITES'.split('').map((letter, i) => (
            <span
              key={`b-${i}`}
              className="text-white transition-all duration-300 group-hover:text-[#FFC107] inline-block group-hover:-translate-y-0.5"
              style={{ transitionDelay: `${(i + 5) * 40}ms` }}
            >
              {letter}
            </span>
          ))}
        </div>
        {showTagline && (
          <span className={`text-zinc-400 uppercase tracking-widest ${s.tagline} mt-1 transition-all duration-500 group-hover:tracking-[0.3em] group-hover:text-zinc-300`}>
            Feel the Taste
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
